import type { ProductAttribute } from '@/shared/types';

export type OnboardingStepId =
  | 'category'
  | 'industry'
  | 'region'
  | 'source'
  | 'author'
  | 'tags';

export interface OnboardingQuestionStep {
  id: OnboardingStepId;
  attribute: ProductAttribute;
  title: string;
  description: string;
}

/** How-to copy shown via the modal header info icon. */
export const ONBOARDING_USAGE_HELP =
  'Expand any category below and pick values you care about — every category is optional. Review the generated filter at the bottom, then apply it to your dashboard. Selections across categories are combined with OR, so products matching any of your choices will be included.';

export const ONBOARDING_QUESTION_STEPS: OnboardingQuestionStep[] = [
  {
    id: 'category',
    attribute: 'category',
    title: 'What threats are you interested in?',
    description: 'Select threat categories you want to monitor on your dashboard.',
  },
  {
    id: 'industry',
    attribute: 'industry',
    title: 'What industry verticals are you interested in?',
    description: 'Choose industries relevant to your organization or research focus.',
  },
  {
    id: 'region',
    attribute: 'region',
    title: 'What regions are you interested in?',
    description: 'Pick geographic regions that matter to your threat landscape.',
  },
  {
    id: 'tags',
    attribute: 'tags',
    title: 'What tags are you interested in?',
    description: 'Select tags that best describe the products you want to see first.',
  },
  {
    id: 'source',
    attribute: 'source',
    title: 'What sources do you trust?',
    description: 'Select intelligence sources you trust or follow most often.',
  },
  {
    id: 'author',
    attribute: 'author',
    title: 'What authors do you trust?',
    description: 'Choose authors or contributors whose content you want to prioritize.',
  },
];

export const ONBOARDING_ATTRIBUTES: ProductAttribute[] = ONBOARDING_QUESTION_STEPS.map(
  (s) => s.attribute
);
